import { render, staticRenderFns } from "./UnassignedTodoView.vue?vue&type=template&id=48e6d4bb"
import script from "./UnassignedTodoView.vue?vue&type=script&lang=js"
export * from "./UnassignedTodoView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports